import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Card } from '../../common/Card';
import CenteredSection from './CenteredSection';
import analytics from '../../../../assets/img/analytics.webp';
import customer from '../../../../assets/img/customer.webp';
import email from '../../../../assets/img/email.webp';
import brand from '../../../../assets/img/brand.webp';
import reporting from '../../../../assets/img/reporting.webp';
import trust from '../../../../assets/img/trust.webp';

const imageMap = {
    one: { image: analytics, alt: 'Comprehensive Reporting & Analysis' },
    two: { image: customer, alt: 'User-Friendly Interface' },
    three: { image: email, alt: 'Enhanced Email Security' },
    four: { image: brand, alt: 'Advanced DNS Record Checking' },
    five: { image: reporting, alt: 'Tailored for Every Use Case' },
    six: { image: trust, alt: 'Trusted by Thousands Worldwide' },
};

const FeatureCardsSection = () => {
    const { t } = useTranslation();
    const cardKeys = ['one', 'two', 'three', 'four', 'five', 'six'];

    return (
        <CenteredSection bg="white" className="text-center">
            <h4 className="text-primary">
                {t('pages.dmarcChecker.whyDmarc.features.title')}
            </h4>
            <p className="small mb-5">
                {t('pages.dmarcChecker.whyDmarc.features.subTitle')}
            </p>
            <Row className="justify-content-center">
                {cardKeys.map((key, index) => (
                    <Col key={index} xs={12} md={6} lg={4} className="mb-4 d-flex justify-content-center">
                        <Card
                            title={t(`pages.dmarcChecker.whyDmarc.cards.${key}.title`)}
                            image={imageMap[key]}
                            features={t(`pages.dmarcChecker.whyDmarc.cards.${key}.li`, { returnObjects: true })}
                        />
                    </Col>
                ))}
            </Row>
        </CenteredSection>
    );
};

export default FeatureCardsSection;
